import {Button, Form, Image, Input, Toast} from "antd-mobile";
import {useTranslation} from "react-i18next";
import {TOASTDURATION} from "../../common/Utils";
import {userModifyPassword} from "../../common/ApiAction";
import {useLocation, useNavigate} from "react-router-dom";

const ModifyPassword = () => {
    const { t } = useTranslation();
    const {state} = useLocation();
    const navigate = useNavigate()

    const onFinish = (values: any) => {
        console.log(values)
        if (values.password !== values.confirmPassword) {
            Toast.show({icon: 'fail', content: "Passwords do not match！", duration: TOASTDURATION})
            return;
        }
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        userModifyPassword(values.password, state?.userInfoId).then((res: any) => {
            Toast.clear();
            Toast.clear();
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                Toast.show({
                    content: 'Password Change Success, Please Login Again',
                    duration: TOASTDURATION,
                    icon: 'success',
                    afterClose: () => {
                        navigate('/userLogin')
                    }
                });
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message || 'Password change failed！', duration: TOASTDURATION})
        })
    }
    return <div style={{backgroundColor: '#F5F6FA', height: '100vh', display: "flex", flexDirection: "column", padding: '0 12px', justifyContent: "center", textAlign: "center"}}>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 25}}>
            <Image src={require('../../assets/icon_ego_logo.jpg')}/>
        </div>
        <Form
            onFinish={onFinish}
            mode={'card'}
            layout='horizontal'
            footer={<Button shape='rounded' block type='submit' color='primary' size='middle'>{t('submit')}</Button>}>
            <Form.Header>{t('change_password_title')}</Form.Header>
            <Form.Item name='password' rules={[{ required: true, message: t('user_password_placeholder') }]}>
                <Input placeholder={t('user_password_placeholder')} />
            </Form.Item>
            <Form.Item name='confirmPassword' rules={[{ required: true, message: t('user_password_confirm_placeholder') }]}>
                <Input placeholder={t('user_password_confirm_placeholder')} />
            </Form.Item>
        </Form>
    </div>
}
export default ModifyPassword
